<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="30" height="30" role="img">
  <title>{{ title }}</title>
  <rect height="26" width="26" [attr.stroke]="border" [attr.fill]="fill" x="2" y="2" rx="5" />

  <ng-container *ngIf="selected && !!color">
    <rect height="18" width="18" [attr.fill]="border" x="6" y="6" />
  </ng-container>
</svg>
